// App Configuration - Project Genesis v1.1
export const APP_NAME = process.env.NEXT_PUBLIC_APP_NAME || "Project Genesis";
export const APP_DESCRIPTION = process.env.NEXT_PUBLIC_APP_DESCRIPTION || "Internal Management System";
export const APP_URL = process.env.NEXT_PUBLIC_APP_URL || "http://localhost:3000";
export const API_URL = process.env.NEXT_PUBLIC_API_URL || "http://localhost:4000";

// Company Configuration
export const COMPANY = {
  name: process.env.NEXT_PUBLIC_COMPANY_NAME || "121 East Development",
  legalName: process.env.NEXT_PUBLIC_COMPANY_LEGAL_NAME || "121 East Development Corporation",
  email: process.env.NEXT_PUBLIC_COMPANY_EMAIL || "info@121edc.com",
  phone: process.env.NEXT_PUBLIC_COMPANY_PHONE || "0917 121 6000",
  address: {
    street: "D2, Pacita Building, Km.7, Mc Arthur Highway",
    area: "Bangkal",
    city: "Davao City",
    country: "Philippines",
  },
  social: {
    facebook: process.env.NEXT_PUBLIC_FACEBOOK_URL || "",
    instagram: process.env.NEXT_PUBLIC_INSTAGRAM_URL || "",
    linkedin: process.env.NEXT_PUBLIC_LINKEDIN_URL || "",
  },
} as const;

// Routes
export const ROUTES = {
  HOME: "/",
  LOGIN: "/login",
  ABOUT: "/about",
  CONTACT: "/contact",
} as const;
